export default __webpack_public_path__ + "static/media/part1_a2_m.126d0978.png";